import { component, prop } from '../../../decorators';

@component({
   name: 'ShowCard'
})
export default class ShowCard {
   @prop({ type: Object, required: true }) show
   @prop({ type: Boolean, default: false }) disabled

   get name() {
      return this.show.name;
   }

   get thumbnailUrl() {
      return this.show.thumbnailUrl;
   }

   gotoShow() {
      if ( !this.disabled ) {
         this.$emit('goto', this.show);
      }
   }
}
